import { SPEAKING } from "../data/content";
import { Reveal } from "./Reveal";
import { Mic2 } from "lucide-react";

const IMG =
  "https://images.pexels.com/photos/6703915/pexels-photo-6703915.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const Speaking = () => {
  return (
    <section
      id="speaking"
      data-testid="speaking-section"
      className="relative py-24 lg:py-32 bg-[#F8FAFC]"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
        <Reveal className="lg:col-span-5">
          <div className="flex items-center gap-4 mb-6">
            <span className="h-px w-10 bg-[#0A192F]/40" />
            <span className="text-xs uppercase tracking-[0.3em] text-[#0A192F]/60">
              Speaking Engagements
            </span>
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-[64px] leading-[1.02] tracking-tight text-[#0A192F]">
            On stage,
            <br />
            with the people
            <br />
            who decide.
          </h2>

          <div className="mt-10 relative overflow-hidden">
            <img
              src={IMG}
              alt="Sean speaking at a healthcare conference"
              className="w-full h-72 object-cover"
              loading="lazy"
            />
          </div>

          <a
            href="#contact"
            data-testid="speaking-cta"
            className="mt-10 inline-flex items-center gap-3 px-7 py-4 border border-[#0A192F] text-[#0A192F] text-sm tracking-wide rounded-full hover:bg-[#0A192F] hover:text-white transition-all duration-300"
          >
            <Mic2 size={16} />
            Request Sean for your stage
          </a>
        </Reveal>

        <Reveal delay={150} className="lg:col-span-7">
          <ul className="divide-y divide-[#0A192F]/10">
            {SPEAKING.map((s, i) => (
              <li
                key={s.event}
                className="group py-7 lg:py-8 first:pt-0 grid grid-cols-[60px_1fr_auto] gap-4 lg:gap-8 items-baseline transition-colors hover:bg-white px-2 -mx-2"
                data-testid={`speaking-row-${i}`}
              >
                <span className="font-serif text-[#0A192F]/40 ticker">
                  {s.year}
                </span>
                <div>
                  <h3 className="font-serif text-xl lg:text-2xl text-[#0A192F]">
                    {s.event}
                  </h3>
                  <p className="mt-2 text-sm text-[#475569]">{s.topic}</p>
                </div>
                <span className="text-[#0A192F] opacity-0 group-hover:opacity-100 transition-opacity">
                  →
                </span>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
};
